import {BASE_URL} from "@/constants/config";
import {request, downloadFile} from "@/utils/request";

export const ALUMNI_ENDPOINTS = {
  base: `${BASE_URL}api/alumni/`,
  list: (id) => `${BASE_URL}api/alumni/${id}/`,
  template: `${BASE_URL}api/alumni/template/`,
  rapport_export: `${BASE_URL}api/alumni/rapport/export/`,
  manuel_upload: `${BASE_URL}api/alumni/rapport/manuel_upload/`,
  fiche6: `${BASE_URL}api/alumni/rapport/analysis/`,
  fiche6_download:(filename) => `${BASE_URL}api/alumni/rapport/analysis/download/${filename}/`,
  fiche7: `${BASE_URL}api/alumni/rapport/fiche7/`,
  certs: (type) => `${BASE_URL}api/alumni/rapport/used-certs/?cert_type=${type}`,
  available_promotions: `${BASE_URL}api/alumni/linkedin/promotion-options/`,
  available_campaigns: `${BASE_URL}api/alumni/linkedin/campaign-options/`,
  available_ecoles: `${BASE_URL}api/alumni/linkedin/ecole-options/`,
  linkedin_export: `${BASE_URL}api/alumni/linkedin/export/`,
  linkedin_import: `${BASE_URL}api/alumni/linkedin/inject/`,
  exportTemplate: (campainId) => `${BASE_URL}api/alumni/export/${campainId}/`,
  uploadInvitation: (campainId) => `${BASE_URL}api/alumni/update/${campainId}/`
};

class Alumni {
  async getFiche6(body) {
    return await request({
      url: ALUMNI_ENDPOINTS.fiche6,
      method: 'POST',
      body: body
    })
  }

  async downloadFiche6(filename) {
    await downloadFile({
      fileName: filename,
      downloadURL: ALUMNI_ENDPOINTS.fiche6_download(filename)
    })
  }

  async deleteAlumni(campaignId, body) {
    return await request({
      url: `${ALUMNI_ENDPOINTS.base}delete/${campaignId}/`,
      method: "DELETE",
      body,
    })
  }

  async editAlumni(campaignId, payload) {
    return await request({
      url: `${ALUMNI_ENDPOINTS.base}edit/${campaignId}/`,
      method: "POST",
      body: payload,
    })

  }

  async getEcoleOptions(payload) {
    const {data} = await request({
      url: ALUMNI_ENDPOINTS.available_ecoles,
      method: "POST",
      body: payload,
    });
    return data?.available_ecoles || [];
  }

  async getCampaignOptions(payload) {
    const {data} = await request({
      url: ALUMNI_ENDPOINTS.available_campaigns,
      method: "POST",
      body: payload
    })
    return data.available_campaign.map(c => ({value: c.id, label: c.name}))
  }

  async getPromotionOptions(payload) {
    const {data} = await request({
      url: ALUMNI_ENDPOINTS.available_promotions,
      method: "POST",
      body: payload,
    });
    return data?.available_promotions || [];
  }
}

export const AlumniService = new Alumni();
